/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const EqualFilesize: core.serialization.ObjectSchema<serializers.EqualFilesize.Raw, Truvity.EqualFilesize> =
    core.serialization.object({
        value: core.serialization.number(),
    });

export declare namespace EqualFilesize {
    export interface Raw {
        value: number;
    }
}
